import SiteLayout from '../components/common/SiteLayout';

export default function NotFound() {
    return (
        <SiteLayout headerVariant="full">
            <div className="flex flex-col items-center px-[15px] py-24 text-center text-white">
                <h1 className="mb-4 text-5xl font-bold md:text-6xl">Page not found</h1>
                <p className="mb-8 text-lg">The page you're looking for doesn't exist.</p>
                <a
                    href="/"
                    className="flex h-[60px] items-center rounded-[20px] border border-[#00E387] bg-[#00E387] px-6 text-xl font-semibold text-[#070038] transition-all duration-300 hover:bg-[#013721] hover:text-[#00E387]"
                >
                    Go to homepage
                </a>
            </div>
        </SiteLayout>
    );
};
